/**
 * Source-of-truth for the `navigationSource` query param appended to Studio
 * URLs opened from the inline create-agent card. Shared between the
 * post-confirm "Refine in Studio" link (`StudioCreateAgentRenderer`) and the
 * published-state settings cog (`CreateAgentCardWithQuery`).
 */
export const STUDIO_NAVIGATION_SOURCE = 'rovo-chat-inline-create-agent';
export const GASV3_ANALYTICS_TOUCHPOINT_NAME = 'rovo-chat-inline-create-agent';
